<template>
  <div class="full-container">
    <div class="container">
      <div class="honor qualification">
        <div class="header">
          <div class="title pi-fz-30">资质证书</div>
          <div class="tool">
            <i
              class="prev iconfont iconicon_pre"
              style="font-size: 50px"
              @click="qualificationSwitch(false)"
            ></i>
            <span class="current">
              <span class="page pi-fz-24">{{
                qualificationPager.currentPage | numberFormat
              }}</span>
              <span>/</span>
              <span class="total pi-fz-24">{{
                qualificationPager.totalPage | numberFormat
              }}</span>
            </span>
            <i
              style="font-size: 50px"
              class="next iconfont iconicon_next"
              @click="qualificationSwitch"
            ></i>
          </div>
        </div>
        <el-carousel
          ref="qualificationCarousel"
          :interval="5000"
          height="350px"
          indicator-position="none"
          @change="qualificationChange"
          style="width: 100%"
        >
          <el-carousel-item
            height="350px"
            v-for="(qItem, qIndex) in qualification"
            :key="'qindex-' + qIndex"
          >
            <div class="tab">
              <div class="wrapper" v-for="(item, index) in qItem" :key="index">
                <div class="item">
                  <el-image :src="item.cover" fit="contain"></el-image>
                  <div class="name">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="honor awards">
        <div class="header">
          <div class="title pi-fz-30">获奖荣誉</div>
          <div class="tool">
            <i
              style="font-size: 50px"
              class="prev iconfont iconicon_pre"
              @click="awardsSwitch(false)"
            ></i>
            <span class="current">
              <span class="page pi-fz-24">{{
                awardsPager.currentPage | numberFormat
              }}</span>
              <span>/</span>
              <span class="total pi-fz-24">{{
                awardsPager.totalPage | numberFormat
              }}</span>
            </span>
            <i
              style="font-size: 50px"
              class="next iconfont iconicon_next"
              @click="awardsSwitch"
            ></i>
          </div>
        </div>
        <el-carousel
          ref="awardsCarousel"
          :interval="5000"
          height="350px"
          indicator-position="none"
          @change="awardsChange"
          style="width: 100%"
        >
          <el-carousel-item
            height="350px"
            v-for="(qItem, qIndex) in awards"
            :key="'qindex-' + qIndex"
          >
            <div class="tab">
              <div class="wrapper" v-for="(item, index) in qItem" :key="index">
                <div class="item" >
                  <el-image :src="item.cover" fit="contain"></el-image>
                  <div class="name">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="honor intellectualProperty">
        <div class="header">
          <div class="title">知识产权</div>
          <div class="tool">
            <i
             style="font-size: 50px"
              class="prev iconfont iconicon_pre"
              @click="intellectualPropertySwitch(false)"
            ></i>
            <span class="current">
              <span class="page pi-fz-24">{{
                intellectualPropertyPager.currentPage | numberFormat
              }}</span>
              <span>/</span>
              <span class="total pi-fz-24">{{
                intellectualPropertyPager.totalPage | numberFormat
              }}</span>
            </span>
            <i
             style="font-size: 50px"
              class="next iconfont iconicon_next"
              @click="intellectualPropertySwitch"
            ></i>
          </div>
        </div>
        <el-carousel
          ref="intellectualPropertyCarousel"
          :interval="5000"
          height="350px"
          indicator-position="none"
          @change="intellectualPropertyChange"
          style="width: 100%"
        >
          <el-carousel-item
            height="350px"
            v-for="(qItem, qIndex) in intellectualProperty"
            :key="'qindex-' + qIndex"
          >
            <div class="tab">
              <div class="wrapper" v-for="(item, index) in qItem" :key="index">
                <div class="item" style="border:none"s>
                  <el-image :src="item.cover" fit="contain" ></el-image>
                  <!-- <div class="name">{{ item.name }}</div> -->
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import data from "./data.js";
import { slicingArray, numberFormat } from "@/utils";

export default {
  name: "product",
  data() {
    return {
      qualification: [],
      qualificationPager: {
        currentPage: 1,
        totalPage: 1,
      },
      awards: [],
      awardsPager: {
        currentPage: 1,
        totalPage: 1,
      },
      intellectualProperty: [],
      intellectualPropertyPager: {
        currentPage: 1,
        totalPage: 1,
      },
    };
  },
  filters: {
    numberFormat(val) {
      return numberFormat(val);
    },
  },
  mounted() {},
  created() {
    this.qualification = slicingArray(data.qualification, 4, 4);
    this.qualificationPager.totalPage = this.qualification.length;

    this.awards = slicingArray(data.awards, 4, 4);
    this.awardsPager.totalPage = this.awards.length;
    const intellectualPropertyData=[]
    for (let index = 1; index <= 41; index++) {
      const num=index<10?`0${index}`:num
      intellectualPropertyData.push({
      name: '',
      cover: require(`@/assets/images/rz/${num}.jpg`)
    })
    }
    console.log(intellectualPropertyData)
    // const intellectualPropertyData=
    this.intellectualProperty = slicingArray(intellectualPropertyData, 6, 6);
    this.intellectualPropertyPager.totalPage = 7;
  },
  methods: {
    qualificationSwitch(add = true) {
      let ref = this.$refs["qualificationCarousel"];
      if (add) {
        ref.next();
      } else {
        ref.prev();
      }
    },
    qualificationChange(index) {
      this.qualificationPager.currentPage = index + 1;
    },
    awardsSwitch(add = true) {
      let ref = this.$refs["awardsCarousel"];
      if (add) {
        ref.next();
      } else {
        ref.prev();
      }
    },
    awardsChange(index) {
      this.awardsPager.currentPage = index + 1;
    },
    intellectualPropertySwitch(add = true) {
      let ref = this.$refs["intellectualPropertyCarousel"];
      if (add) {
        ref.next();
      } else {
        ref.prev();
      }
    },
    intellectualPropertyChange(index) {
      this.intellectualPropertyPager.currentPage = index + 1;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/theme.scss";

div {
  width: 100%;
}
.container {
  padding-top: 50px;
  padding-bottom: 20px;
}
/** page style */

.title {
  padding: 10px 0 30px;
  font-size: 30px;
  font-weight: bold;
}

.honor {
  padding-bottom: 70px;
  .header {
    display: flex;
    justify-content: space-between;
    text-align: left;

    // .title {}

    .tool {
      display: flex;
      justify-content: flex-end;
      font-size: 14px;

      .current > .page {
        font-weight: bold;
      }

      > i {
        font-size: 28px;
        color: $color-text-grey;
        cursor: pointer;

        &:hover {
          color: $color-text-primary;
        }
      }
    }
  }

  .tab {
    height: 100%;
    display: flex;
    width: calc(100% + 16px);
    margin-left: -8px;
    margin-right: -8px;

    .wrapper {
      padding: 8px;
      height: 100%;
    }

    .item {
      height: 100%;
      border: 1px solid #f5f5f5;
      padding: 30px;

      .el-image {
        height: 260px - 20px;
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutus/honor/index.vue